import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { FormFieldConfig, FieldSelectedValue } from '../../../model/form.model';
import { CamelCasePipe } from "../../../utils/camel-case.pipe";
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-mat-date-field',
  standalone: true,
  imports: [MatDatepickerModule, MatInputModule, MatIconModule,MatFormFieldModule,ReactiveFormsModule,CamelCasePipe,FormsModule,CommonModule],
  providers: [provideNativeDateAdapter()],
  templateUrl: './mat-date-field.component.html',
  styleUrl: './mat-date-field.component.scss',
})
export class MatDateFieldComponent implements OnChanges{
  @Input()
  field!: FormFieldConfig | undefined;
  @Input() form!: FormGroup;

  @Output() dateChange = new EventEmitter<FieldSelectedValue>();
  public inputData: any;
  constructor() {}

  ngOnChanges(): void {
    if (this.field && this.form.controls[this.field.fieldName]) {
      this.inputData =this.field.selectedValue;
    }
  }

  onDateChange(FieldName: string, event: any): void {
    if (this.field) {
      this.field.selectedValue = this.formatDateToMMDDYYYY(event);
      this.dateChange.emit({
        FieldName: FieldName,
        Value: this.field.selectedValue,
      });
    }
    if(this.field?.selectedValue){
    this.inputData = new Date(this.field?.selectedValue);
    }
    else{
      this.inputData = "";
    }
  }

  onMonthSelected(FieldName: string, event: Date, datepicker: any): void {
    if (!this.field || !event) {
      return;
    }
    const month = String(event.getMonth() + 1).padStart(2, '0');
    this.field.selectedValue = `${month}/01/${event.getFullYear()}`;
    const selectedDate = new Date(event.getFullYear(), event.getMonth(), 1);
    this.form.get(FieldName)?.setValue(selectedDate, { emitEvent: false });
    this.inputData = selectedDate;
    this.dateChange.emit({ FieldName, Value: this.field.selectedValue });
    datepicker.close();
  }
  
  clearDate(): void {
    if (this.field) {
      this.inputData = '';
      this.field.selectedValue = '';
      this.form.get(this.field.fieldName)?.setValue('');
      this.form.get(this.field.fieldName)?.markAsTouched();
      this.dateChange.emit({FieldName: this.field.fieldName,Value: ''});
    }
  }

  formatDateToMMDDYYYY(dateInput: string | Date) {
    let date: Date;
    
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === 'string') {
      // Parse ISO 8601 date string (YYYY-MM-DD) without timezone conversion
      // to avoid off-by-one errors due to timezone differences
      const parts = dateInput.split('-');
      if (parts.length === 3) {
        const year = Number.parseInt(parts[0], 10);
        const month = Number.parseInt(parts[1], 10) - 1;
        const day = Number.parseInt(parts[2], 10);
        date = new Date(year, month, day);
      } else {
        date = new Date(dateInput);
      }
    } else {
      return '';
    }
    
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
}
